import { useCallback, useContext, useEffect, useState } from 'react';
import moment from 'moment';

import { getCafe24Payments, getPaymentList, getInicisPaymentList } from '../modules/NetworkFunction';
import ShopModeContext from '../contexts/ShopModeContext';

const usePaymentStatus = (token, userNo) => {
  const { shopMode } = useContext(ShopModeContext);
  const [isPaid, setIsPaid] = useState(false); // 결제 여부
  const [paymentData, setPaymentData] = useState([]); // 결제 내역
  const [filteredPaymentData, setFilteredPaymentData] = useState([]);
  const [totalPaymentCount, setTotalPaymentCount] = useState(0);
  const accessToken = sessionStorage.getItem('accessToken');

  // db에 저장된 결제내역 가져오기
  const getPayments = useCallback(() => {
    
    getPaymentList(
      {
        endDate: moment().format('YYYY-MM-DD'),
      },
      (data) => {
        setPaymentData((prev) => {
          if (shopMode === 'cafe24') {
            return [...prev, ...data.paymentList];
          }

          return data.paymentList;
        });

        const isValidPayment = data.paymentList.some((payment) => {
          return (
            moment().isBefore(payment.expirationDate) && payment.refundYn === 0
          );
        });
        setIsPaid(isValidPayment);
      },
      (err) => {
        console.log(err);
      },
      token
    )
    //  : 
    // getInicisPaymentList(
    //   {
    //     endDate: moment().format('YYYY-MM-DD'),
    //   },
    //   (data) => {
    //     console.log(data.paymentList);
    //     setPaymentData(data.paymentList);

    //     const isValidPayment = data.paymentList.some((payment) => {
    //       return (
    //         moment().isBefore(payment.expirationDate) && payment.refundYn === 0
    //       );
    //     });
    //     setIsPaid(isValidPayment);
    //   },
    //   (err) => {
    //     console.log(err);
    //   },
    //   token
    // );

  }, [token, shopMode]);

  useEffect(() => {
    if (shopMode === 'cafe24') {
      if (!accessToken) return;
      getCafe24Payments(
        {
          token: accessToken,
          mallId: localStorage.getItem('mallId'),
          startDate: moment().subtract('1', 'M').format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
        },
        (data) => {
          setPaymentData(data);
          const isValidPayment = data.some((payment) => {
            const afterOneMonth = moment(payment.pay_date).add(1, 'months');
            return (
              payment.payment_status === 'paid' &&
              moment().isBefore(afterOneMonth)
            );
          });
          setIsPaid(isValidPayment);

          // 카페24에 유효한 결제내역 없을 때 db에 저장된 결제내역 가져오기 > 유료 요금제 적용해준 사용자 확인
          if (!isValidPayment) {
            getPayments();
          }
        },
        (err) => {
          console.log(err);
        },
        token
      );
    }
    // if (shopMode === 'makeshop') {
    //   getPayments();
    // }
  }, [token, shopMode, accessToken, getPayments]);

  const getPaymentsByDate = useCallback(
    (startDate, endDate, page) => {
      if (shopMode === 'cafe24') {
        getCafe24Payments(
          {
            token: accessToken,
            mallId: localStorage.getItem('mallId'),
            startDate,
            endDate,
          },
          (data) => {
            setFilteredPaymentData(data);
            setTotalPaymentCount(data.length);

            getPaymentList(
              {
                startDate,
                endDate,
                page,
              },
              (data) => {
                setFilteredPaymentData((prev) => [
                  ...prev,
                  ...data.paymentList,
                ]);
                setTotalPaymentCount((prev) => prev + data.totalCount);
              },
              (e) => {},
              token
            );
          },
          (e) => {},
          token
        );
      }
      else {
        getInicisPaymentList(
          {
            startDate,
            endDate,
            userNo,
          },
          (data) => {
            console.log(data);
            setFilteredPaymentData(data.paymentList);
            setTotalPaymentCount(data.totalCount);
          },
          (e) => {
            console.log(e);
          },
          token
        );
      }
    },
    [token, shopMode, accessToken]
  );

  const paidData = paymentData.filter(
    (payment) => payment.payment_status === 'paid' || payment.refundYn === 0
  );

  const startDate =
    paidData.length > 0 &&
    moment(paidData[0]['pay_date'] || paidData[0]['paymentDate']).format(
      'YYYY-MM-DD'
    );

  // db 결제내역에 저장된 만료일 or 마지막 결제일로부터 한달 뒤 날짜
  const endDate =
    paidData.length > 0 &&
    (moment(paidData[0]['expirationDate']).format('YYYY-MM-DD') ||
      moment(paidData[0]['pay_date'] || paidData[0]['paymentDate'])
        .add('1', 'M')
        .subtract('1', 'd')
        .format('YYYY-MM-DD'));

  const period = startDate && endDate ? `${startDate} ~ ${endDate}` : '';

  return {
    isPaid,
    paymentData,
    getPaymentsByDate,
    filteredPaymentData,
    period,
    totalPaymentCount,
  };
};

export default usePaymentStatus;
